import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { hasAnonymization } from '@collections/users';
import { Store } from '@ngrx/store';
import { AvatarBackgroundSizes } from 'mojo-avatar';
import { filterOutPagesBasedOnPrivileges, MojoPrivilegesService } from 'mojo-privileges';
import { SubPage } from 'mojo-privileges/lib/models/sub-pages';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';

import { getAssignsAssociationsTotal } from '@modules/assigns/store';
import { CandidateAdapter } from '@shared/models';

import { ComponentsConfig, ComponentsPrivileges } from '../components.abstract.config';

@Component({
  selector: 'mojo-candidate-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() candidate: CandidateAdapter;

  pages: SubPage[];

  avatarBackground = AvatarBackgroundSizes.cover;
  privileges: ComponentsPrivileges;
  isAnonymized$ = this.store.select(hasAnonymization);

  private subscription = new Subscription();

  constructor(
    private store: Store<{}>,
    private componentsConfig: ComponentsConfig,
    private privilegeService: MojoPrivilegesService,
    private cdr: ChangeDetectorRef,
  ) {
    this.privileges = this.componentsConfig.privileges;
    this.pages = [
      { title: 'Details', link: 'details' },
      {
        title: 'APPLICATION HISTORY',
        link: 'assigns',
        privileges: this.privileges.assigned.jobs,
      },
      {
        title: 'Notes',
        link: 'notes',
        privileges: this.privileges.candidates.notes,
      },
    ];
    this.addFilesPageForNotAnonymized();
  }

  private addFilesPageForNotAnonymized() {
    this.subscription.add(
      this.isAnonymized$.pipe(take(1)).subscribe((isAnonymized) => {
        if (!isAnonymized) {
          this.pages.push({
            title: 'Files',
            link: 'attachments',
            anyPrivilege: [
              this.privileges.candidates.files,
              this.privileges.candidates.resumes,
              this.privileges.candidates.filesReadOnly,
            ],
          });
        }
      }),
    );
  }

  ngOnInit() {
    this.privilegeService.userPrivileges$.subscribe((privileges) => {
      this.pages = filterOutPagesBasedOnPrivileges(this.pages, privileges);
    });
    this.subscription.add(
      this.store
        .select(getAssignsAssociationsTotal)
        .pipe(filter((count) => !!count || count === 0))
        .subscribe((assignsCount) => {
          const assignsPage = this.pages.find((page) => page.link === 'assigns');
          if (assignsPage) {
            assignsPage.title = `APPLICATION HISTORY (${assignsCount})`;
            this.pages = [...this.pages];
            this.cdr.detectChanges();
          }
        }),
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
